import { t } from '@lingui/macro';
import Grid from '@material-ui/core/Grid/Grid';
import { trans } from 'config/LinguiConfig';
import Button from 'MUI_Kit/components/CustomButtons/Button';
import CustomInput from 'MUI_Kit/components/CustomInput/CustomInput';
import React from 'react';
import DV from 'variables/DV';
import BaseModal from '../BaseComponent/BaseModal';
import CircleColorPicker from '../ColorPicker/CircleColorPicker';
import Routes from '../../router/routes';
import { handleApi } from '../../helper/helper';
import { createTags, updateTags } from '../../api/api';

class TagModal extends BaseModal {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
      title: this.getTitle(),
      loading: false,
      color: '',
      ...this.getDataFromRouter(),
    };
    this.goPathWhenClose = Routes.tag.path;
  }

  getTitle() {
    let { id } = this.getDataFromRouter();
    if (id) return t`Cập nhật tag khách hàng`;
    return t`Thêm tag khách hàng`;
  }

  valid = () => {
    const { name, color } = this.state;
    if (!!!name) {
      DV.showNotify(t`Vui lòng nhập tên tag`, 'danger');
      return false;
    }
    if (!!!color) {
      DV.showNotify(t`Vui lòng chọn màu`, 'danger');
      return false;
    }
    return true;
  };

  handleSubmit = () => {
    const { name, color, id } = this.state;

    if (!this.valid()) return;

    if (id) {
      this.update({ name: name, color }, id);
    } else {
      this.add({ name: name, color });
    }
  };

  add = async (data) => {
    this.setState({ loading: true });
    let { success, error } = await handleApi(createTags(data));
    this.setState({ loading: false });
    if (success) {
      this.close(true);
      DV.showNotify(t`Thêm tag thành công`);
    } else DV.showNotify(error, 'danger');
  };

  update = async (payload, id) => {
    this.setState({ loading: true });
    let { success, data, error } = await handleApi(updateTags(payload, id));
    this.setState({ loading: false });

    if (success) {
      this.close(true);
      DV.showNotify(t`Cập nhật tag thành công`);
    } else DV.showNotify(error, 'danger');
  };

  renderFooter() {
    return (
      <Button loading={this.state.loading} onClick={this.handleSubmit} color="info">
        {t`Hoàn tất`}
      </Button>
    );
  }

  renderBody() {
    let { name, color } = this.state;
    console.log(name, color);
    return (
      <Grid>
        <CustomInput
          labelText={t`Tên tag`}
          inputProps={{
            type: 'text',
            value: name || '',
            onChange: this.handleChange('name'),
          }}
        />
        <Grid container spacing={1} alignContent="center">
          <Grid item xs={12} container spacing={2}>
            <Grid item className="flex-start-row">
              {t`Màu tag`}
            </Grid>
            <Grid item xs={1}>
              <div
                style={{
                  backgroundColor: color,
                  height: 30,
                  width: '100%',
                  borderRadius: 5,
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CircleColorPicker onChange={(color) => this.setState({ color })} />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default TagModal;
